// @ts-nocheck


import React from 'react';



import { vehicleTariffEnum } from '../../../lib/enum';

import { withUserAccess } from '../../withUserAccess';
import { InnerList } from '../components';






const COLUMNS = [
{
  title: 'Марка',
  dataIndex: 'vehicleModel.brandName'
},
{
  title: 'Модель ТС',
  dataIndex: 'vehicleModel.name'
},
{
  title: 'Тип ТС',
  dataIndex: 'vehicleModel.typeMdm'
}];

export const VehicleTariffBrandList = (props) => {
  return (
    <>
      <InnerList
        {...props}
        type={vehicleTariffEnum.byBrand}
        extColumns={COLUMNS} />

    </>);

};

export default withUserAccess(VehicleTariffBrandList);
